import { resolveAuthToken } from './utils/auth-utils';

export {};

const defaultPolicyJson = decodeURIComponent(
  document.getElementById('site-consent-policy')?.dataset
    .defaultConsentPolicy ?? '',
);

let defaultPolicy;

try {
  defaultPolicy = defaultPolicyJson ? JSON.parse(defaultPolicyJson) : undefined;
} catch (e) {
  console.log(
    '[site-consent-policy] failed to parse the default consent policy',
    defaultPolicyJson,
  );
}

window.consentPolicyManager.init(
  {
    consentPolicy: defaultPolicy,
    baseUrl: document.location.origin,
  },
  () => resolveAuthToken(),
);
